import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { MainComponent } from './main/main.component';
import { TaskTrackerItemComponent } from './task-tracker-item/task-tracker-item.component';

const routes: Routes = [{ path: '', component: MainComponent },
      { path: 'task', component: TaskTrackerItemComponent },
      { path: 'task/:id', component: TaskTrackerItemComponent }];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
